module.exports = __webpack_public_path__ + "img/l_dj.64e9f2d0.png";